import React from "react";

// import brands data
import { serviceSelections } from "../../../../constants";

const ServiceSelection = () => {
  return (
    <section className="min-h-[15vh] bg-tertiary flex items-center ">
      <div className="container mx-auto flex py-3 xls:py-0  items-center flex-wrap justify-evenly md:justify-between gap-4 xls:gap-0 ">
        {serviceSelections.map((service, idx) => {
          return (
            <div
              key={idx}
              // className="  flex flex-col justify-center items-center transition-all  p-2 hover:cursor-pointer bg-accent hover:bg-[#925a2b] rounded-xl shadow-xl shadow-primary    xl:w-[220px] lg:w-[290px] md:w-[230px] sm:w-[285px] w-[210px]"
              className="flex flex-col justify-center items-center p-2 
              transition-all duration-300 ease-in-out  bg-accent  
              rounded-xl shadow-xl shadow-primary 
              xl:w-[220px] lg:w-[290px] md:w-[230px] sm:w-[285px] w-[210px]"
              // for making it a button add these class
              // hover:scale-105 hover:cursor-pointer hover:bg-[#925a2b]
            >
              <img src={service.img} alt="" className="w-[50px]" />
              <span className="text-white">{service?.title}</span>
            </div>
          );
        })}
      </div>
    </section>
  );
  // return (
  //   <section className="min-h-[146px] bg-tertiary flex items-center">
  //     <div className="container mx-auto grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 items-center justify-evenly md:justify-between gap-4 ">
  //       {serviceSelections.map((service, idx) => {
  //         return (
  //           <div
  //             key={idx}
  //             className=" flex flex-col justify-center items-center  p-2 hover:cursor-pointer bg-secondary border  rounded-xl  w-full"
  //           >
  //             <img src={service.img} alt="" className="w-[50px]" />
  //             <span className="text-accent">{service?.title}</span>
  //           </div>
  //         );
  //       })}
  //     </div>
  //   </section>
  // );
};

export default ServiceSelection;
